import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { InsighttNotification } from '../../helpers/insightt-notification';
import {
  EXPORT_SPOTTED_VEHICLES_CSV_INITIAL_STATE,
  ExportSpottedVehiclesReportInput,
  SpottedVehiclesActions,
} from './spotted-vehicles-types';
import { client } from '../../shared/apollo';
import { createSpottedVehiclesReportCsvWhere, getBranchFilter } from './spotted-vehicles-utils';
import {
  CountSpottedVehicleReportListDocument,
  SpottedVehicleReportListDocument,
  SpottedVehicleReportListQuery,
} from '@rapid-recovery-agency-inc/insightt-graphql';
import { AppState } from '../../redux/store';

export const resetSpottedVehiclesReportCsv = createAction(SpottedVehiclesActions.RESET);

export const fetchSpottedVehiclesCsv = createAsyncThunk<
  {
    records: SpottedVehicleReportListQuery['spottedVehicleReports'];
    timezone: string;
  },
  ExportSpottedVehiclesReportInput
>(
  SpottedVehiclesActions.FETCH_CHUNK_REPORT_CSV,
  async (filter, { fulfillWithValue, rejectWithValue, getState }) => {
    const state = getState() as AppState;
    const timezone = state.system.session.timezone as string;

    try {
      const { data } = await client.query({
        query: SpottedVehicleReportListDocument,
        variables: {
          where: createSpottedVehiclesReportCsvWhere(filter),
          take: EXPORT_SPOTTED_VEHICLES_CSV_INITIAL_STATE.chunkSize,
          skip: filter.skip,
          branch: getBranchFilter(filter.branch),
        },
      });
      return fulfillWithValue({
        records: data.spottedVehicleReports,
        timezone,
      });
    } catch (err) {
      InsighttNotification('error', 'Spotted CSV Error', err);
      return rejectWithValue(new Error(String(err)));
    }
  },
  {},
);
export const startFetchingSpottedVehiclesCsv = createAsyncThunk<number, ExportSpottedVehiclesReportInput>(
  SpottedVehiclesActions.START_EXPORT_REPORT_CSV,
  async (filter, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { data } = await client.query({
        query: CountSpottedVehicleReportListDocument,
        variables: {
          where: createSpottedVehiclesReportCsvWhere(filter),
          branch: getBranchFilter(filter.branch),
        },
      });
      fetchSpottedVehiclesCsv(filter);
      return fulfillWithValue(data.aggregateSpottedVehicleReport?._count?._all ?? 0);
    } catch (err) {
      InsighttNotification('error', 'Spotted CSV Error', err);
      return rejectWithValue(new Error(String(err)));
    }
  },
  {},
);
